__turbopack_context__.v({
  "button": "AuthModals-module__QTgBMG__button",
  "form": "AuthModals-module__QTgBMG__form",
  "formWrapper": "AuthModals-module__QTgBMG__formWrapper",
  "input": "AuthModals-module__QTgBMG__input",
  "modal": "AuthModals-module__QTgBMG__modal",
  "noAccount": "AuthModals-module__QTgBMG__noAccount",
  "noAccountButton": "AuthModals-module__QTgBMG__noAccountButton",
  "otherLogin": "AuthModals-module__QTgBMG__otherLogin",
  "otherLoginButtons": "AuthModals-module__QTgBMG__otherLoginButtons",
  "title": "AuthModals-module__QTgBMG__title",
  "toastContainer": "AuthModals-module__QTgBMG__toastContainer",
});
